class ColetorConfigForm {
    constructor($element, $scope, api) {
        this.$element = $element
        this.api = api
        this.$apply = $scope.$apply.bind($scope)
    }

    $onInit() {
        if (!this.coletorConfig.id) {
            this.coletorConfig.operacao = 'UPLOAD'
            this.coletorConfig.documento = 'NFE'

            if (this.empresas && this.empresas.length)
                this.coletorConfig.empresa = this.empresas[0]
        }
    }

    onKeyUp($ev) {
        if ($ev.key == 'Escape') {
            this.onCancel({ $event: $ev, coletorConfig: this.coletorConfig })
            $ev.stopPropagation()
        }
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('coletorConfigForm', {
        controller: ['$element', '$scope', 'api', ColetorConfigForm],
        bindings: {
            coletorConfig: '<',
            onSave: '&',
            editing: '<',
            onCancel: '&',
            loading: '<',
            empresas: '<'
        },
        template: `
            <div class="well well-xs" ng-submit="$ctrl.onSave({$event: $event, coletorConfig: $ctrl.coletorConfig})">
                <form name="form">
                    <div class="row">
                        <div class="form-group col-xs-12 col-md-7">
                            <label>Empresa</label>
                            <ui-select ng-model="$ctrl.coletorConfig.empresa" theme="bootstrap" ng-disabled="$ctrl.editing">
                                <ui-select-match placeholder="Selecione uma empresa...">{{$select.selected.razaoSocial}}</ui-select-match>
                                <ui-select-choices repeat="empresa in $ctrl.empresas | filter: $select.search track by empresa.id">
                                    <strong>Razão social: </strong>
                                    <span ng-bind-html="empresa.razaoSocial | limitToDots: 40 | highlight: $select.search"></span>
                                    <br>
                                    <strong>Raiz do CNPJ: </strong>
                                    <span ng-bind-html="empresa.raizCnpj | cpfCnpj | highlight: $select.search"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>

                        <div class="form-group col-xs-12 col-md-5">
                            <label>Operação</label>
                            <div class="smart-form">
                                <div class="inline-group" style="margin: 0px">
                                    <label class="radio no-break" ng-class="{'radio-disabled': $ctrl.coletorConfig.id}">
                                        <input
                                            type="radio"
                                            ng-model="$ctrl.coletorConfig.operacao"
                                            ng-disabled="$ctrl.coletorConfig.id"
                                            value="UPLOAD">
                                        <i></i> Enviar para o EF
                                    </label>

                                    <label class="radio no-break" ng-class="{'radio-disabled': $ctrl.coletorConfig.id}">
                                        <input
                                            type="radio"
                                            ng-model="$ctrl.coletorConfig.operacao"
                                            ng-disabled="$ctrl.coletorConfig.id"
                                            value="DOWNLOAD">
                                        <i></i> Baixar do EF
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-xs-12 col-md-7">
                            <label>Diretório</label>
                            <div class="input-group">
                                <span class="input-group-addon"><i class="fa fa-folder"></i></span>
                                <div class="icon-addon addon-md">
                                    <input 
                                        type="text"
                                        ng-required="true"
                                        ng-model="$ctrl.coletorConfig.diretorio"
                                        ng-form="form"
                                        ng-keyup="$ctrl.onKeyUp($event)"
                                        name="diretorio"
                                        class="form-control"
                                        placeholder="Informe o diretório dos XML" />
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-xs-12 col-md-5 slide-animation" ng-show="$ctrl.coletorConfig.operacao == 'DOWNLOAD'">
                            <label>Tipo de documento</label>
                            <div class="smart-form">
                                <div class="inline-group" style="margin: 0px">
                                    <label class="radio no-break" ng-class="{'radio-disabled': $ctrl.coletorConfig.id}">
                                        <input
                                            type="radio"
                                            ng-model="$ctrl.coletorConfig.documento"
                                            ng-disabled="$ctrl.coletorConfig.id"
                                            value="NFE">
                                        <i></i> NF-e
                                    </label>

                                    <label class="radio no-break" ng-class="{'radio-disabled': $ctrl.coletorConfig.id}">
                                        <input
                                            type="radio"
                                            ng-model="$ctrl.coletorConfig.documento"
                                            ng-disabled="$ctrl.coletorConfig.id"
                                            value="CTE">
                                        <i></i> CT-e
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row actions">
                        <div class="col-xs-12 text-right">
                            <button class="btn btn-primary" type="submit" ng-disabled="form.$invalid || $ctrl.loading">
                                <span ng-hide="$ctrl.loading">
                                    Salvar
                                </span>
                                <span ng-show="$ctrl.loading">
                                    Salvando... <i class="fa fa-spinner fa-spin"></i>
                                </span>
                            </button>
                            <button class="btn btn-default" type="button" ng-disabled="$ctrl.loading" ng-click="$ctrl.onCancel({$event: $event, coletorConfig: $ctrl.coletorConfig})">Cancelar</button>
                        </div>
                    </div>
                </form>
            </div>
        `
    })
